import React from 'react';

import { Svg, Path, SvgProps } from 'react-native-svg';

import { colors } from '@/constants/colors';

const FoamRollerIcon: React.FC<SvgProps> = (props) => {
  const {
    width = '100%',
    height = '100%',
    color = colors.brand.primary,
    ...rest
  } = props;

  return (
    <Svg viewBox={'0 0 88 88'} width={width} height={height} {...rest}>
      <Path
        clipRule={'evenodd'}
        d={
          'M60.6 75.9c4.8 2.1 17.4-.1 24.1-15.1 7-15.7 1.1-26.9-2.2-27.8L17.1 13.8c-4.3 0-11.8.8-15.7 11.2-3.6 9.8.2 16.8 3.1 19zm18.3-38c-5.3-2.6-13.2 2.5-17.6 11.4s-3.8 18.3 1.5 20.9S76 67.7 80.4 58.8s3.7-18.3-1.5-20.9z'
        }
        fill={color}
        fillRule={'evenodd'}
      />
    </Svg>
  );
};

export default FoamRollerIcon;
